import logSicoop from '../../assets/logo-sicoop-comercios.png';

export function LogoSicoopFondo({ tamano }) {
    return (
        <img
            src={logSicoop}
            alt="logosicoop"
            // width={`${tamano}px`}
            // height={`${tamano - 20}px`}
            // style={{
            //     position: 'absolute',
            //     zIndex: '1',
            //     top: -200,
            //     left: '0',
            //     right: '0',
            //     bottom: 150,
            //     margin: 'auto',
            //     opacity: '0.2'

            // }}
            //centrar imagen al medio, se puede usar en cualquier imagen
            style={{
                position: 'absolute',
                zIndex: '1',
                top: '30%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                opacity: '0.2',
                maxWidth: `${tamano}px`,
                maxHeight: `${tamano - 50}px`,
                width: 'auto',
            }}
        />
    );
}